// extracted by mini-css-extract-plugin
export default {"container":"GameOver_container__ngd4P","definitionBox":"GameOver_definitionBox__3Wjjg","gif":"GameOver_gif__T2U+2","button":"GameOver_button__C4YbD"};